module.exports = __webpack_public_path__ + "static/media/logo_fmps_ar.574ead91.png";